import React, { useState , useEffect} from "react";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
//import MenuIcon from '@material-ui/icons/Menu';
//import SearchIcon from '@material-ui/icons/Search';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
//import DirectionsIcon from '@material-ui/icons/Directions';

const useStyles = makeStyles((theme) => ({
  root: {
    opacity: 0.8,
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',

  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,

    fontFamily: 'Montserrat'
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    margin: 4,
  },
  paper: {
    opacity: 0.5,
  }
}));

export default function RuleInput(props) {
  const [formData, setFormData] = useState({ rule: '', other: '' });
  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

  useEffect(() => {
    if (props.onChange) {
      props.onChange(formData)
    }
  }, [formData.rule, formData.other])




  const [input, setInput] = useState('');
  const classes = useStyles();


  const onChange = (e) => {
      setInput(e.currentTarget.value);
  };

  return (
    <Paper className={classes.root} variant="outlined">
      <InputBase
        className={classes.input}
        placeholder="New rule"
        label="New rule"
        name="rule"
        size="small"
        multiline
        inputProps={{ maxLength: 1000 }}
        value={formData.rule}
        onChange={handleChange}
        onKeyPress={(ev) => {
          if (ev.key === 'Enter') {
            ev.preventDefault();
            if (formData.rule.trim().length>0) {
              props.onClick();
            }
          }
        }}
      />
      <Divider className={classes.divider} orientation="vertical" flexItem/>
      <IconButton color="primary" className={classes.iconButton} aria-label="directions" size="small" onClick={props.onClick} disabled={formData.rule.length<1} >
        <AddCircleOutlineRoundedIcon size="small" />
        <a style={{fontSize:"12px"}} >&nbsp;add rule</a>
      </IconButton>

    </Paper>
  );
}
